// extracted by mini-css-extract-plugin
module.exports = {"button":"AudioSample_button__7_bsm","root":"AudioSample_root__o08dK"};